import React from 'react';
import { Row, Col, Table, NavLink, Image } from 'react-bootstrap';

// Extras
import utils from '../../_helpers/utils';
import { ErrorMessage, FactionIconColumn } from '../Extras';

export default class Reskins extends React.Component {
  constructor(props) {
    super(props);

    this.state = { }

    this.request = utils.request.bind(this);
  }

  componentDidMount() {
    this.request(`/items/${this.props.sAPBDB}/reskins`, 'reskins');
  }

  render() {
    if (this.state.reskinsError) {
      return <ErrorMessage noVCenter error={this.state.reskinsError} />
    }

    if (this.state.reskinsLoaded) {
      if (!this.state.reskins.length) {
        return (
          <Row>
            <Col className="text-center">
              <i>No reskins found.</i>
            </Col>
          </Row>
        )
      }

      return (
        <Row className="p-0">
          <Table className="item-table">
            <tbody className="small-height">
            {this.state.reskins.map(reskin => (
              <Item key={`reskin-${reskin.sAPBDB}`} item={reskin} setSelected={this.props.setSelected} />
            ))}
            </tbody>
          </Table>
        </Row>
      )
    }

    return utils.loadingCircle(true);
  }
}

class Item extends React.Component {
  render() {
    const item = this.props.item;

    return (
      <tr onClick={() => this.props.setSelected(item.sAPBDB)}>
        <td className="small-width">
          <NavLink to={`/items/${item.sAPBDB}`}>
            <Image 
              src={item.eHUDImage} 
              alt={item.sDisplayName}
              onError={utils.handleImageError} />
          </NavLink>
        </td>
        <td>
          <NavLink 
            to={`/items/${item.sAPBDB}`}
            dangerouslySetInnerHTML={{__html: utils.convertColorCode(item.sDisplayName)}}
          />
        </td>
        <td>R {item.nMinRating}</td>
        <FactionIconColumn enf={item.bEnforcer} crim={item.bCriminal} />
      </tr>
    )
  }
}
